import { useState } from "react";
import { Loader2 } from "lucide-react";
import { buildPayload, useSubmit, validateContact } from "../../lib/forms";
import { ConsentBlock, ContactFields, Field, FormError, Honeypot, NativeSelect, SuccessPanel, TextArea } from "./FormBits";

const TOPICS = ["In-home care", "Housing and residential services", "Careers", "Partnerships", "Privacy request", "General question"];
const REGIONS = [{ value: "gta", label: "Greater Toronto Area, Ontario" }, { value: "other", label: "Another location" }];
const INITIAL = { topic: "", region: "", city: "", message: "", name: "", email: "", phone: "", preferred_contact: "", privacy_consent: false, marketing_consent: false, website: "" };

export const ContactForm = () => {
  const [form, setForm] = useState(INITIAL);
  const [localErr, setLocalErr] = useState("");
  const { submit, submitting, error, reference, reset } = useSubmit();
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  if (reference) {
    return (
      <SuccessPanel reference={reference} title="Thank you. Your message has been received." testId="contact-success" resetLabel="Send another message"
        onReset={() => { setForm(INITIAL); reset(); }}>
        <p>We will review your message and respond as soon as we can.</p>
      </SuccessPanel>
    );
  }

  const onSubmit = (e) => {
    e.preventDefault();
    const err = !form.topic ? "Please choose a topic." : !form.region ? "Please select your location."
      : form.message.trim().length < 5 ? "Please enter a message." : validateContact(form);
    setLocalErr(err || "");
    if (!err) submit("/public/contact", buildPayload(form));
  };

  return (
    <form onSubmit={onSubmit} noValidate className="card-warm p-6 sm:p-10 space-y-6" data-testid="contact-form">
      <ContactFields form={form} set={set} prefix="contact" />
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Topic" htmlFor="contact-topic" required>
          <NativeSelect id="contact-topic" value={form.topic} onChange={(v) => set("topic", v)} options={TOPICS} testId="contact-input-topic" />
        </Field>
        <Field label="Location" htmlFor="contact-region" required>
          <NativeSelect id="contact-region" value={form.region} onChange={(v) => set("region", v)} options={REGIONS} testId="contact-input-region" />
        </Field>
      </div>
      <TextArea id="contact-message" label="Message" value={form.message} onChange={(v) => set("message", v)} required max={2000} rows={5}
        hint="Please do not include detailed medical, financial or identification information." testId="contact-input-message" />
      <ConsentBlock form={form} set={set} prefix="contact" purpose="message" />
      <Honeypot value={form.website} onChange={(v) => set("website", v)} />
      <FormError message={localErr || error} testId="contact-error" />
      <button type="submit" disabled={submitting} className="btn-pill btn-primary disabled:opacity-60" data-testid="contact-submit-button">
        {submitting ? <><Loader2 className="h-4 w-4 animate-spin" /> Sending…</> : "Send message"}
      </button>
    </form>
  );
};
